<template>
  <div>
    <div>

          <el-dropdown @command="emitAssignContact" trigger="click">
                  <el-button type="primary">

                      <!-- display the selected contact only if the object is defined 
                           or it's equals to the string "unassigned". otherwise means the API did not return yet -->
                      <div v-if="this.selectedContact.firstname != undefined ||
                                 this.selectedContact == 'Unassigned'"
                      >  

                          <span v-if="this.selectedContact != 'Unassigned'">
                              {{selectedContact.firstname + " " + selectedContact.lastname}}
                          </span>

                          <span v-else >
                                Unassigned
                          </span>
                          
                          <i class="el-icon-arrow-down el-icon--right"></i>

                      </div>
                  </el-button>

              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                    command="Unassigned"
                >
                Unassigned
                </el-dropdown-item>
                <el-dropdown-item
                   v-for="contact in this.mycontacts"
                   :key="contact.userid"
                   :command="contact"
                >
                  {{contact.firstname + " " + contact.lastname}}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>

      <!-- <select
        class="selector"
        v-model="selectedContact"
        @change="emitAssignContact()"
      >
      <option>
        Unassigned
      </option>
        <option
          v-for="(contact, index) in this.mycontacts"
          :key="index"
          :value="contact.userid"
          >{{ contact.firstname }} {{ contact.lastname }}</option
        >
      </select> -->
    </div>
  </div>
</template>

<script>
import EventService from "@/services/EventService.js";
export default {
  props: {
    propertyid: String,
    machineid: String,
    selectedUserId: String
  },
  data() {
    return {
      mycontacts: [],
      selectedContact: {}
    };
  },
  created() {
    //if this is being called for a issue that doesn't belong for a machine only to property then call for property
  if(this.machineid != undefined)
    {
       this.handleAssignForMachine();
    } 
    else if(this.propertyid != undefined)
    {
        this.handleAssignForProperty(this.propertyid);
    }
  },
  watch:{
    propertyid:{
       handler(newVal, oldVal){
       if(newVal != undefined)
         this.handleAssignForProperty(newVal);

       }
    }
  },
  methods: {
    emitAssignContact(contact) {

        this.selectedContact = contact;

        if(contact != "Unassigned")
        {
            this.$emit("contact-assigned", contact.userid);
        }
        else
        {
            this.$emit("contact-assigned", "Unassigned");
        }

    },
    handleAssignForProperty(propertyid){

          EventService.getPropertyInvitedUsers(propertyid).then( response => {
              this.mycontacts = response.data.signedupusers;

              if(this.selectedUserId == null)
              {
                  this.selectedContact = "Unassigned";
              }
              else
              {
                  this.selectedContact = this.mycontacts.filter(i => i.userid == this.selectedUserId)[0];
              }
          });
    },
    handleAssignForMachine(){

        EventService.getMachineInvitedUsers(this.machineid).then( response => {
          
            this.mycontacts = response.data.users;

            // if it's called at issue creation it doesn't have user assigned then select the first as default
            if(this.selectedUserId == null)
            {
                  this.selectedContact = "Unassigned";
            }
            else
            {
                this.selectedContact = this.mycontacts.filter(i => i.userid == this.selectedUserId)[0];
            }
        });
    }
  },
};
</script>

<style scoped>
.selector {
  border-style: solid;
}
</style>
